<template>
  <div class="flex gap-2">
    <ViewTypeSelector v-if="!maxSmall" />
    <div class="flex gap-1">
      <TaskCreate>
        <Button
          variant="primary"
          size="md"
          :label="$t('components.buttons.new_task')"
        >
          <template #start>
            <Icon name="plus" />
          </template>
        </Button>
      </TaskCreate>
    </div>
  </div>
</template>

<script setup>
// Import Components
import ViewTypeSelector from "@/Pages/Tasks/Partials/Header/ViewTypeSelector.vue";
import { Button } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { TaskCreate } from "@/SharedComponents/TaskCreate";

// Breakpoints
const { maxSmall } = useBreakpoints();
</script>
